import * as z from "zod/v4";
import { number, string } from "zod/v4";
export const ConfirmAddToCart = z.object({
  productId: number(),
  variantId: number(),
  quantity: number(),
  productTitle: string(),
});
